import React, { useState } from "react";
import "./register.css";
import firebase from "../../firebase.js";
import { Container, Row, Form, Col, Button } from "react-bootstrap";
import NavBar from "../../component/navbar/navbar";
import Footer from "../../component/footer/footer";

function Register() {
  // ici on initialise nos hooks

  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmedPassword, setConfirmedPassword] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [zip, setZip] = useState("");
  const [phonenumber, setPhoneNumber] = useState("");

  // référence à la collection users_info

  const ref = firebase.firestore().collection("users_info");

  // début fonction inscription

  const register = (event) => {
    event.preventDefault();

    //  début fonction de vérification des valeurs entrées, si retourne true, continue le code
    if (checkInputs(true)) {
      const createdAt = new Date();

      // appel fonction firebase
      firebase
        .auth()

        // création utilisateur avec mot de passe dans la partie Authentication de Firebase
        .createUserWithEmailAndPassword(email, password)

        // puis, prends les données de l'utilisateur crée
        .then((user) => {
          const user_uid = user.user.uid;
          const user_email = user.user.email;

          // et enregistre les dans la collection users_info ainsi que les valeurs entrées dans les inputs par l'utilisateur
          ref.doc(user_uid).set({
            firstname,
            lastname,
            address,
            city,
            zip,
            phonenumber,
            id: user_uid,
            email: user_email,
            createdAt: createdAt,
            role: 0,
          });

          // un timeout pour laisser le temps à firestore d'enregistrer les données
          setTimeout(function () {
            window.location.href = "/";
          }, 1000);
        })
        .catch((err) => {
          alert(err);
        });
    }
  };

  // début fonction de vérification des inputs

  function checkInputs() {
    // les différents regex adapté à chaque input

    var stringRegex = /^[a-z ,.'-]+$/i;
    var addressRegex = /^[a-z0-9é ,.'-]+$/i;
    var phoneRegex = /^((\+)33|0)[1-9](\d{2}){4}$/g;
    var zipRegex = /^(?:[0-8]\d|9[0-8])\d{3}$/;

    // on initialise les variables "status" comme false,
    // pour procéder à une vérification si true plus tard

    var firstnameStatus = false;
    var lastnameStatus = false;
    var passwordStatus = false;
    var addressStatus = false;
    var cityStatus = false;
    var zipStatus = false;
    var phoneStatus = false;

    // si le nom n'est pas vide, est validé par le regex
    // et pas plus de 30 caractères, alors le status devient true

    if (firstname == "") {
      alert("Prénom non rempli.");
    } else if (!stringRegex.test(firstname)) {
      alert(
        "Prénom non conforme. Veuillez retirer les chiffres et caractères spéciaux et réessayer."
      );
    } else if (firstname.length > 30) {
      alert("Prénom trop long. Limite à 30 caractères.");
    } else {
      firstnameStatus = true;
    }

    if (lastname == "") {
      alert("Nom non rempli.");
    } else if (!stringRegex.test(lastname)) {
      alert(
        "Nom non conforme. Veuillez retirer les chiffres et caractères spéciaux et réessayer."
      );
    } else if (lastname.length > 30) {
      alert("Nom trop long. Limite à 30 caractères.");
    } else {
      lastnameStatus = true;
    }

    // si password vide ou différent, ne valide pas

    if (password !== confirmedPassword) {
      alert("Confirmation de mot de passé échouée. Veuillez réessayer.");
    } else if (password == "") {
      alert("Le mot de passe n'a pas été rempli");
    } else {
      passwordStatus = true;
    }

    if (address == "") {
      alert("Adresse non remplie.");
    } else if (address > 100) {
      alert("L'adresse ne peut faire plus de 100 caractères");
    } else if (!addressRegex.test(address)) {
      alert("Adresse non conforme.");
    } else {
      addressStatus = true;
    }

    if (city == "") {
      alert("Ville non remplie.");
    } else if (city > 50) {
      alert("La ville ne peut faire plus de 50 caractères");
    } else if (!stringRegex.test(city)) {
      alert("Ville non conforme.");
    } else {
      cityStatus = true;
    }

    if (zip == "") {
      alert("Code postal non rempli.");
    } else if (!zipRegex.test(zip)) {
      alert("Code postal non conforme.");
    } else {
      zipStatus = true;
    }

    if (phonenumber == "") {
      alert("Numéro de téléphone non rempli.");
    } else if (!phoneRegex.test(phonenumber)) {
      alert("Numéro de téléphone non conforme.");
    } else {
      phoneStatus = true;
    }

    // si tous les status renvoient true, alors checkInput()
    // renvoie true et procède à l'exécution du code dans la fonction register

    if (
      firstnameStatus == true &&
      lastnameStatus == true &&
      addressStatus == true &&
      phoneStatus == true &&
      passwordStatus == true &&
      cityStatus == true &&
      zipStatus == true
    ) {
      return true;
    }
  }

  return (
    <div>
      <NavBar />
      <Container>
        <Row>
          <Col>
            <div className="register-box">
              <h1 className="register-title">S'inscrire</h1>
              <Form>
                <Form.Group controlId="formBasicFirstName">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    type="firstname"
                    value={firstname}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicLastName">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    type="lastname"
                    value={lastname}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicEmail">
                  <Form.Label>Adresse mail</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPassword">
                  <Form.Label>Mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </Form.Group>
                <Form.Group controlId="formBasicConfirmedPassword">
                  <Form.Label>Confirmer le mot de passe</Form.Label>
                  <Form.Control
                    type="password"
                    value={confirmedPassword}
                    onChange={(e) => setConfirmedPassword(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicAddress">
                  <Form.Label>Adresse</Form.Label>
                  <Form.Control
                    type="address"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicCity">
                  <Form.Label>Ville</Form.Label>
                  <Form.Control
                    type="address"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicZip">
                  <Form.Label>Code Postal</Form.Label>
                  <Form.Control
                    type="address"
                    value={zip}
                    onChange={(e) => setZip(e.target.value)}
                  />
                </Form.Group>

                <Form.Group controlId="formBasicPhoneNumber">
                  <Form.Label>Numéro de téléphone</Form.Label>
                  <Form.Control
                    type="phonenumber"
                    value={phonenumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Form.Group>

                <Button
                  variant="success"
                  style={{ backgroundColor: "#0f6860" }}
                  type="submit"
                  onClick={register}
                >
                  Confirmer l'inscription
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
      <Footer />
    </div>
  );
}

export default Register;
